import React from 'react';
import { useStore } from '@betgames/bg-state-manager';
import { useUnmount } from '@betgames/bg-tools';
import { GAME_MESSAGE_DURATION } from 'constants/constants';
import { gameMessage } from 'store/GameMessage';
import { IMessage } from 'store/GameMessage/interfaces';

export const useNextMessage = (): IMessage => {
    const messagesList = useStore(gameMessage.store);
    const [message, setMessage] = React.useState<IMessage>(null);

    const runNextMessage = React.useCallback(() => {
        const messagesListNew = gameMessage.store.value;
        const nextMessage = messagesListNew.length ? { ...messagesListNew[0] } : null;

        if (nextMessage) {
            nextMessage.id = window.setTimeout(() => {
                gameMessage.store.update((draft) => {
                    draft.shift();
                });
                runNextMessage();
            }, nextMessage.duration || GAME_MESSAGE_DURATION);

            setMessage(nextMessage);
        } else {
            setMessage((state) => {
                window.clearTimeout(state.id);
                return null;
            });
        }
    }, []);

    React.useEffect(() => {
        if (messagesList.length && !message) {
            runNextMessage();
        }
    }, [messagesList, message]);

    useUnmount(() => {
        if (message) {
            window.clearTimeout(message.id);
        }
    });

    return message;
};
